import noop from 'lib/function/noop'
import { createContext } from 'react'

type SaveClickHanlder = () => void

export const RecommendationSaveClickTrackerContext = createContext<SaveClickHanlder>(noop)
